import { render, staticRenderFns } from "./spaceship-record.vue?vue&type=template&id=b68c3432&scoped=true&"
import script from "./spaceship-record.vue?vue&type=script&lang=js&"
export * from "./spaceship-record.vue?vue&type=script&lang=js&"
import style0 from "./spaceship-record.vue?vue&type=style&index=0&id=b68c3432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68c3432",
  null
  
)

export default component.exports